import { ApiService } from '../../services'
import {Unauthorized} from '../../helpers/unauthorized.handler'
export const WallpaperModule = {
    namespaced: true,
    state: {
        loading: false,
        Deleteloading: false,
        data : {
            columns: [

                {
                    label: 'SKU/Code',
                    field: 'series',
                    sort: 'asc',
                    width : '150',
                
                },
                
                {
                    label: 'Brand/Supplier',
                    field: 'brand_name',
                    sort: 'asc',
                    clickable: true,
                    width: '250',
                   
                },
                {
                    label: 'Name',
                    field: 'name',
                    sort: 'asc',
                    clickable: true,
                    width: '250',
                   
                },
                {
                    label: 'Image',
                    field: 'thumb',
                    sort: 'asc',  
                    width: '120',                 
                },

                {
                    label: 'Description',
                    field: 'description',
                },

             
                {
                    label: 'Price',
                    field: 'formatted_price',
                    align : 'right',
                    width: '100',
                   
                },
               /*  {
                    label: 'Qty',
                    field: 'qty',
                    align : 'right',
                    width: '100',
                   
                }, */
              
            ],
            rows: [],
        },
        length : 25,
        page : 0,
        total : 1,
        searchTerm : null,
        filters : null,

        formStatus : 'create',
        endpoint : 'wallpaper',
        formRecord : {},

    },
    actions : {
        GetBrandRelationship({ rootState,dispatch },params) {
            const { endpoint } = rootState.WallpaperModule
            return new Promise((resolve) => {
                ApiService.get(`${endpoint}/${params.endpoint}`, params).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    Unauthorized(dispatch, error)
                })
            })
        },
        async GetCollection({ rootState,dispatch }) {
            const { endpoint } = rootState.WallpaperModule
            return await new Promise((resolve) => {
                ApiService.get(`${endpoint}/collections`, {}).then((response) => {
                        resolve(response.data)
                    }).catch(error => {
                        Unauthorized(dispatch, error)
                    })
            })
        },
        async GetBrands({ rootState,dispatch }) {
            const { endpoint } = rootState.WallpaperModule
            return await new Promise((resolve) => {
                ApiService.get(`${endpoint}/brands`, {}).then((response) => {
                        resolve(response.data)
                    }).catch(error => {
                        Unauthorized(dispatch, error)
                    })
            })
        },
        async GetNextCode({ rootState,dispatch }) {
            const { endpoint } = rootState.WallpaperModule
            return await new Promise((resolve) => {
                ApiService.get(`${endpoint}/code`, {}).then((response) => {
                        resolve(response.data)
                    }).catch(error => {
                        Unauthorized(dispatch, error)
                    })
            })
        },

        async asyncGetData({ rootState, commit,dispatch }) {
            const { loading, length, page, filters, searchTerm, endpoint} = rootState.WallpaperModule
            return await new Promise((resolve) => {
                if (loading === false) {
                    commit('LoadingTrue')
                    const params = { length: length, page: page, term: searchTerm, filters: filters }
                    ApiService.get(`${endpoint}/data`, params).then((response) => {
                        commit('SetPage', response.data.current_page)
                        commit('SetTotal', response.data.total)
                        commit('SetData', response.data.data)
                        commit('LoadingFalse')
                        resolve(response.data.data)
                    }).catch(error => {
                        //reject(error)
                        Unauthorized(dispatch,error)
                    })
                }
            })
        },
        
        StoreRecord({ rootState,commit},payload){
            var self = this
            return new Promise((resolve, reject) => {
                const { loading, endpoint} = rootState.WallpaperModule;
                if (!loading) {
                    commit('LoadingTrue')
                    ApiService.store(`${endpoint}`,payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        UpdateRecord({ rootState,commit},payload){
            var self = this
            return new Promise((resolve, reject) => {
                const { loading, endpoint } = rootState.WallpaperModule;
                if (!loading) {
                    commit('LoadingTrue')
                    ApiService.update(`${endpoint}`,payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async DeleteRecord({ rootState,commit},payload){
            var self = this
            return await new Promise((resolve, reject) => {
                const { endpoint, Deleteloading } = rootState.WallpaperModule;
                if (!Deleteloading) {
                    commit('DeleteloadingTrue')
                    const tokens = [];
                    payload.forEach(element => {
                        tokens.push(element.token_id)
                    });
                    ApiService.delete(`${endpoint}`,tokens).then((response) => {
                        commit('DeleteloadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('DeleteloadingFalse')
                        reject(error)
                    })
                }
            })
        },

        saveImport({ rootState, commit }, payload) {
            var self = this
            return new Promise((resolve, reject) => {
                const { endpoint, loading } = rootState.WallpaperModule;
                if (!loading) {
                    commit('LoadingTrue')
                    ApiService.store(`${endpoint}/save-import`,payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
    },
    mutations: {
        LoadingFalse: (state) => {
            state.loading = false
        },
        LoadingTrue : (state) => {
            state.loading = true
        },
        DeleteloadingFalse: (state) => {
            state.Deleteloading = false
        },
        DeleteloadingTrue : (state) => {
            state.Deleteloading = true
        },
        SetData(state, payload){
            state.data.rows = payload
        },
        SetPage: (state, payload)=>{
            state.page = payload
        },
        SetTotal: (state, payload)=>{
            state.total = payload
        },
        SetLength: (state, payload)=>{
            state.length = payload
        },
        SetCode: (state, payload)=>{
            state.form.item_code = payload
        },
        
        SetFormStatusCreate: (state)=>{
            state.formStatus = 'create'
        },

        SetFormStatusUpdate: (state) => {
            state.formStatus = 'update'
        },
        SetFormRecord: (state,payload) => {
            state.formRecord = payload
        },

    },
    getters: {
        Loading: state => state.loading,
        Deleteloading: state => state.Deleteloading,
        dialogIsOpen: state => state.dialogIsOpen,
        data: state => state.data,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        form: state => state.form,
        columns: state => state.data.columns,
        FormStatus: state => state.formStatus,
        FormRecord: state => state.formRecord,
    }
}


